import MainCalendar from '../components/calendario/MainCalendar';

const CalendarioPage = () => {
    return (
        <div className="flex flex-col w-full min-h-screen">
            <main className="flex-1 px-4 pb-4 pt-20 w-full">
                <div className="w-full pb-24">
                    <MainCalendar />
                </div>
            </main>
        </div>
    );
};

export default CalendarioPage;